/* repo/reserMfa*/
import { omit, isEmpty } from "ramda";
import {
  insert as insertApi,
  drop as dropApi,
  isString,
} from "./api";
import { withDecoded, flattenData } from "./";
import authenticator from "authenticator";

function mapToModel(data: object): ResetSTAN {
  return withDecoded(ResetSTANCodec, data, (decoded) => ({
    ...decoded,
  }));
}

function mapToChageset(terminal: Data): Data {
  return terminal;
}
import {ResetSTANCodec, ResetSTAN, Data } from "../store/resetSTAN/types";

export async function save(terminal: Data): Promise<ResetSTAN> {

  return insertApi({
    nestedResourcePath: ["Terminal","ResetSTAN"],
    id: terminal.terminal_id,
    data: { data: mapToChageset(terminal) },
  }).then((response) =>
    mapToModel(
      flattenData(
        isString(response.data) ? JSON.parse(response.data) : response.data
      )
    )
  );
}
